var React = require('react');

function Change (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"evenodd"},[React.createElement("path",{"fillRule":"nonzero","d":"M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16m0-1.4c8.063 0 14.6-6.537 14.6-14.6S24.063 1.4 16 1.4 1.4 7.937 1.4 16 7.937 30.6 16 30.6","key":0}),React.createElement("path",{"d":"M21.683 12.444H9v-1.208h12.692l-2.36-2.36.833-.876L24 11.836l-3.835 3.84-.833-.88zM11.317 19.232H24v1.208H11.308l2.36 2.36-.833.876L9 19.84 12.835 16l.833.88z","key":1})]));
}

Change.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Change;

Change.default = Change;
